import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box,
  CircularProgress
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const DocumentUploadModal = ({ open, onClose, onUpload }) => {
  const [file, setFile] = useState(null);
  const [docType, setDocType] = useState('');
  const [customName, setCustomName] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUploadClick = async () => {
    if (!file || !docType) return;
    
    // Определяем итоговое имя документа
    const finalName = docType === 'Другое' ? customName.trim() : docType;
    if (!finalName) return;

    setIsUploading(true);
    try {
      // onUpload - это функция, которая инкапсулирует вызов API загрузки
      // и последующее обновление массива specificationFiles проекта
      await onUpload(file, finalName);
      // Сбрасываем стейт после успешной загрузки
      setFile(null);
      setDocType('');
      setCustomName('');
      onClose();
    } catch (error) {
      console.error('Ошибка загрузки документа:', error);
    } finally {
      setIsUploading(false);
    }
  };

  const isUploadDisabled = !file || !docType || (docType === 'Другое' && !customName.trim()) || isUploading;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Загрузка документа</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          
          <Button
            variant="outlined"
            component="label"
            startIcon={<CloudUploadIcon />}
            fullWidth
          >
            {file ? file.name : 'Выбрать файл (PDF, DOCX, JPG)'}
            <input
              type="file"
              hidden
              accept=".pdf,.doc,.docx,image/jpeg,image/png"
              onChange={handleFileChange}
            />
          </Button>

          <FormControl fullWidth size="small">
            <InputLabel>Тип документа</InputLabel>
            <Select
              value={docType}
              label="Тип документа"
              onChange={(e) => setDocType(e.target.value)}
            >
              <MenuItem value="Договор">Договор</MenuItem>
              <MenuItem value="Проект">Проектная документация</MenuItem>
              <MenuItem value="Смета">Смета</MenuItem>
              <MenuItem value="Акт">Акт выполненных работ</MenuItem>
              <MenuItem value="чертежи для сборки">чертежи для сборки</MenuItem>
              <MenuItem value="чертежи для монтажа">чертежи для монтажа</MenuItem>
              <MenuItem value="Другое">Другое (указать вручную)</MenuItem>
            </Select>
          </FormControl>

          {docType === 'Другое' && (
            <TextField
              fullWidth
              size="small"
              label="Название документа"
              value={customName}
              onChange={(e) => setCustomName(e.target.value)}
              placeholder="Например: Разрешение на строительство"
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Отмена</Button>
        <Button 
          onClick={handleUploadClick} 
          variant="contained" 
          disabled={isUploadDisabled}
          startIcon={isUploading ? <CircularProgress size={20} /> : null}
        >
          Загрузить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentUploadModal;
